"use strict";

exports.__esModule = true;
exports.unitScaleFactory = unitScaleFactory;
var _d3Scale = require("d3-scale");
var _Catalogs = require("../../../Catalogs");
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Return a function which can create a linear scale for the given units.
 */
function unitScaleFactory(units, numericScale) {
  if (units === "PERCENT") {
    return function (from, to) {
      return (0, _d3Scale.scaleLinear)().rangeRound([from, to]).domain([0, 100]);
    };
  }
  if (units === "FRACTIONAL_PERCENT") {
    return function (from, to) {
      return (0, _d3Scale.scaleLinear)().rangeRound([from, to]).domain([0, 1]);
    };
  }
  if (units === "DEGREE") {
    return function (from, to) {
      return (0, _d3Scale.scaleLinear)().rangeRound([from, to]).domain([0, 360]);
    };
  }
  var definition = (0, _Catalogs.getUnitDefinition)(units);
  if (definition.type === "number") {
    return numericScale;
  }
  var retained = new Set();
  return function (from, to, values) {
    var isNumericArray = values.every(function (value) {
      return typeof value === "number";
    });
    if (isNumericArray) {
      return numericScale(from, to, values);
    }
    for (var _iterator = _createForOfIteratorHelperLoose(values), _step; !(_step = _iterator()).done;) {
      var value = _step.value;
      retained.add(value);
    }
    return (0, _d3Scale.scaleBand)().rangeRound([from, to]).domain(Array.from(retained));
  };
}